import {h, Component, Fragment} from "preact";
import {route} from "preact-router";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import {TicketHeader, TicketBody, EndedTicketPopups} from "../mobile-pages/ticket-ltn.jsx";
import Page from "../../../services/page-data-feed";
import LFeed from "../../../services/live-feed";
import Ticket from "../utils/ticket-logic.jsx";

import FullSite from "./full-site";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as L from "../desktop-templates/live-general.jsx";
import * as T from "../desktop-templates/prematch-right-col.jsx";
import * as P from "../mobile-templates/sports.jsx";
import * as I from "../utils/icons.jsx";
import * as E from "../desktop-templates/prematch-single-event.jsx";

import MenuFull from "../desktop-components/menu-full.jsx";
import {MenuSportsOnly} from "../desktop-components/menu-sports-only.jsx";
import MenuTopleagues from "../desktop-components/menu-topleagues.jsx";
import MenuSearchEvent from "../desktop-components/menu-search-event.jsx";
import MenuBetServices from "../desktop-components/menu-bet-services.jsx";
import MenuTimeFilter from "../desktop-components/menu-time-filter.jsx";

import PrematchCarousel from "../desktop-components/prematch-carousel.jsx";

import PrematchLastMinute from "../desktop-components/prematch-last-minute.jsx";
import PrematchLiveEvents from "../desktop-components/prematch-live-events.jsx";
import PrematchTournamentSelector from "../desktop-components/prematch-tournament-selector.jsx";
import PrematchTournament from "../desktop-components/prematch-tournament.jsx";
import PrematchEvent from "../desktop-components/prematch-event.jsx";

import TicketCheckBet from "../desktop-components/ticket-check-bet.jsx";
import TicketLoadBet from "../desktop-components/ticket-load-bet.jsx";
import TicketFastBet from "../desktop-components/ticket-fast-bet.jsx";

import {LivePage as LiveMobile} from "../mobile-pages/live.jsx";

export default function Live({sportId}) {
	return <FullSite><LiveTemplate {...{sportId}} /></FullSite>;
}

export function LiveTemplate({sportId}) {
	return <div class="font-roboto">
		<div class="flex h-screen border-b border-b-zinc-950 bg-blue-whale-900 text-white">
			<LiveContent sportId={sportId} />
		  <div class="scrollbar-fancy w-72 p-3 gap-3 flex-none overflow-y-scroll">
			<T.ColumnTicketWrappper>
				<T.TicketTopRow>
					<TicketHeader />
				</T.TicketTopRow>
				<TicketBody />
				<EndedTicketPopups />
			</T.ColumnTicketWrappper>
			<M.BlankSeparator />
			<TicketLoadBet />
			<M.BlankSeparator />
			<TicketCheckBet />
		  </div>
		</div>
	</div>
}

export class LiveContent extends LiveMobile {
	setSportRoute(sportId) {
		route('/live/general/'+sportId)
	}
	render() {
		const menu = LFeed.menu;
		return <L.LivePage>
			{true ? <L.TopRowContainer>
			  <L.ContainerLink>
				<L.TopPageLink href="/prematch">sport home</L.TopPageLink>
				<L.TopPageLink href="/live/general" active={true}>general view</L.TopPageLink>
				<L.TopPageLink href="/live">event view</L.TopPageLink>
			  </L.ContainerLink>
			  <L.SearchBarSection>
				<L.SearchBarWrapper>
				  <L.SearchBarContainer></L.SearchBarContainer>
				</L.SearchBarWrapper>
			  </L.SearchBarSection>
			  <L.TopRowIcon></L.TopRowIcon>
			  <L.TopRowIcon></L.TopRowIcon>
			  <L.TopRowIcon></L.TopRowIcon>
			</L.TopRowContainer> : null}
			<L.SportScrollBar>
			  <L.SportsContainer>
				<L.SportButton 
					onClick={e => this.setFavourites()} 
					active={this.FAVOURITES_TAG == this.state.sport}>
					<P.SportIconBox><I.FavouritesIcon class="h-full text-kobaaccent-500" /></P.SportIconBox>
					<P.SportName>Favourites</P.SportName>
				</L.SportButton>
				<L.SportButton onClick={e => route('/prematch')}>
					<P.SportIconBox><I.Stopwatch class="h-full" /></P.SportIconBox>
					<P.SportName>Prematch</P.SportName>
				</L.SportButton>
				{menu && Object.values(menu).sort((a, b) => a.order - b.order).map(sport => {
					return <L.SportButton 
							   active={sport.id == this.state.sport} 
							   onClick={e => this.setSport(sport)} 
							>
						<P.SportIconBox>
							<P.SportIcon sport={sport} />
							<span class="block absolute -top-2 -right-2 text-xs">{sport.count}</span>
						</P.SportIconBox>
						<P.SportName>
							<span class={sport.id == this.state.sport? 'font-bold text-kobaaccent-600' : ''}>{sport.name}</span>
						</P.SportName>
						{sport.id == this.state.sport && <I.UpCaretIcon class="w-5 h-5 absolute -bottom-2 text-kobaaccent-600 fill-red-600" />}
					</L.SportButton>
				})}
			  </L.SportsContainer>
			</L.SportScrollBar>
			<L.LiveSportContainer>
				{this.getCurrentSport() && <L.CurrentSportNameRow sportid={this.getCurrentSport().id.replace('/sport/','')}>
				<L.CurrentSportName>
					<div class="flex items-center justify-start gap-2.5">
						<P.SportIcon sport={this.getCurrentSport()} />
						<span class="text-xl">{this.getCurrentSport().name}</span>
					</div>
				</L.CurrentSportName>
			  </L.CurrentSportNameRow>}
			  {this.getCurrentSport() && <L.LiveEventsContainer key={this.state.sport}>
			  	{this.getCategories().map(tournament => 
			  		<Tournament key={tournament.id} tournament={tournament} />
			  	)}
			  </L.LiveEventsContainer>}
			  <L.LiveEventsContainer>
				
			  </L.LiveEventsContainer>
			</L.LiveSportContainer>
		</L.LivePage>
	}
}

export class Tournament extends Component {
	state = {showstats: {}};

	toggleEventStats(event) {
		if (!!this.state.showstats[event.id]) {
			delete this.state.showstats[event.id];
		} else {
			this.state.showstats[event.id] = true;
		}

		this.setState({});
	}

	render({tournament}) {
		return <div>
			<L.TournamentNameRow>
			  <L.FlagContainer><M.RegionFlagIcon category={{label: tournament.label.split(' - ')[0]}} /></L.FlagContainer>
			  <L.TournamentName>{tournament.name}</L.TournamentName>
			</L.TournamentNameRow>
			{Object.values(tournament.sub).map(event => <L.FullEventRow key={event.id}>
			  <L.InfoSportContainerClickable onClick={e => route('/live'+event.id)} class="cursor-pointer hover:underline">
				<L.InfoSportRow>
				  {event.status.timer && <L.Minutes>{event.status.timer}</L.Minutes>}
				  <L.Phase>{event.status.phase}</L.Phase>
				  <L.MarketsNumber>{event.markets}</L.MarketsNumber>
				</L.InfoSportRow>
				<L.InfoTeamRow>
				  <L.TeamName>{event.home}</L.TeamName>
				  <L.TeamScoreContainer>
					<L.TeamScore>{event.current.result[0]}</L.TeamScore>
					<L.DashScore>-</L.DashScore>
					<L.TeamScore>{event.current.result[1]}</L.TeamScore>
				  </L.TeamScoreContainer>
				  <L.TeamName>{event.away}</L.TeamName>
				  <L.SpaceDiv></L.SpaceDiv>
				  <div class="flex flex-col items-center justify-center pt-3">
				  		<L.SportItemContainer><I.PlayIcon class="h-3" /></L.SportItemContainer>
					  	{event.sport === '/sport/1'
						  ? <L.SportItemContainer>
								<a href="javascript:void(0);" onClick={e => {e.stopPropagation(); this.toggleEventStats(event);}}>
									<I.StatsIconRegular class="h-3" />
								</a>
						  	</L.SportItemContainer>
						  : null}
					  	{!!this.state.showstats[event.id]
						  ? <div class="relative">{<Statsbox event={event} onClose={() => this.toggleEventStats(event)} />}</div>
						  : null}
				  </div>
				</L.InfoTeamRow>
			  </L.InfoSportContainerClickable>
			  <MarketSection markets={event.sub || {}} />
			</L.FullEventRow>)}
		</div>
	}
}

export class Statsbox extends Component {
	state = {
		hidden: false
	}

	componentWillMount() {
		window.document.addEventListener('mousedown', this.mouseDownListener = e => {
			if (!e.composedPath().includes(this.root)) {
				// console.info(e.composedPath(), this.root);
				if (!!this.props.onClose) {
					this.props.onClose();
				} else {
					this.setState({hidden: true});
				}
			}
		});
	}
	componentWillUnmount() {
		window.document.removeEventListener('mousedown', this.mouseDownListener);
	}
	statsDangerAttackIcon() {
		return <span
			title={window.Translation(msg`Attacco Pericoloso`)}
			class="inline-block h-5 w-5"
			style={"background-position:center center;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 22 22'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill-rule='nonzero'%3E%3Cg fill='%23838383'%3E%3Cpath d='M8.87 6.064a.5.5 0 0 1 .64.013l.062.065 3.636 4.546a.5.5 0 0 1-.718.69l-.063-.066-3.636-4.545a.5.5 0 0 1 .078-.703z'/%3E%3Cpath d='M12.427 10.688a.5.5 0 0 1 .831.55l-.05.074-3.636 4.546a.5.5 0 0 1-.83-.55l.05-.075 3.635-4.545z'/%3E%3C/g%3E%3Cg fill='%23545454'%3E%3Cpath d='M11.602 6.064a.5.5 0 0 1 .64.013l.063.065 3.636 4.546a.5.5 0 0 1-.718.69l-.063-.066-3.636-4.545a.5.5 0 0 1 .078-.703z'/%3E%3Cpath d='M15.16 10.688a.5.5 0 0 1 .831.55l-.05.074-3.636 4.546a.5.5 0 0 1-.83-.55l.05-.075 3.635-4.545z'/%3E%3C/g%3E%3Cg fill='%23B2B2B2'%3E%3Cpath d='M6.142 6.064a.5.5 0 0 1 .64.013l.063.065 3.636 4.546a.5.5 0 0 1-.718.69l-.063-.066-3.636-4.545a.5.5 0 0 1 .078-.703z'/%3E%3Cpath d='M9.7 10.688a.5.5 0 0 1 .831.55l-.05.074-3.636 4.546a.5.5 0 0 1-.83-.55l.05-.075L9.7 10.688z'/%3E%3C/g%3E%3C/g%3E%3Cpath d='M0 0h22v22H0z'/%3E%3C/g%3E%3C/svg%3E\")"}
		/>;
	}
	statsAttackIcon() {
		return <span
			title={window.Translation(msg`Attacco`)}
			class="inline-block h-5 w-5"
			style={"background-position:center center;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 22 22'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23545454' fill-rule='nonzero'%3E%3Cpath d='M9.142 6.064a.5.5 0 0 1 .64.013l.063.065 3.636 4.546a.5.5 0 0 1-.718.69l-.063-.066-3.636-4.545a.5.5 0 0 1 .078-.703z'/%3E%3Cpath d='M12.7 10.688a.5.5 0 0 1 .831.55l-.05.074-3.636 4.546a.5.5 0 0 1-.83-.55l.05-.075 3.635-4.545z'/%3E%3C/g%3E%3Cpath d='M0 0h22v22H0z'/%3E%3C/g%3E%3C/svg%3E\")"}
		/>;
	}
	statsBallPossesionIcon() {
		return <span
			title={window.Translation(msg`Possesso Palla`)}
			class="inline-block h-5 w-5"
			style={"background-position:center center;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 22 22'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23666' fill-rule='nonzero' d='M14.5 13a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm0 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-7-8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm0 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z'/%3E%3Cpath fill='%23666' d='M14.5 6H16L7.5 16H6z'/%3E%3Cpath d='M0 0h22v22H0z'/%3E%3C/g%3E%3C/svg%3E\")"}
		/>;
	}
	statsShotOnTargetIcon() {
		return <span
			title={window.Translation(msg`Tiri in Porta`)}
			class="inline-block h-5 w-5"
			style={"background-position:center center;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 22 22'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill-rule='nonzero'%3E%3Cg fill='%23888'%3E%3Cpath d='M2.5 6h1v9h-1zM18.556 6h1v9h-1z'/%3E%3Cpath d='M2.5 6h17v1h-17z'/%3E%3C/g%3E%3Cg fill='%23278467'%3E%3Cpath d='M11.623 7v3.109h-.9V7zM11.623 12.891V16h-.9v-3.109zM12.62 11.073l3.11.054-.016.9-3.11-.054zM6.73 11.073l3.109.054-.016.9-3.11-.054z'/%3E%3Cpath d='M11.173 7.982a3.518 3.518 0 1 0 0 7.036 3.518 3.518 0 0 0 0-7.036zm0 .9a2.618 2.618 0 1 1 0 5.236 2.618 2.618 0 0 1 0-5.236z'/%3E%3C/g%3E%3C/g%3E%3Cpath d='M0 0h22v22H0z'/%3E%3C/g%3E%3C/svg%3E\")"}
		/>;
	}
	statsShotOffTargetIcon() {
		return <span
			title={window.Translation(msg`Tiri Fuori`)}
			class="inline-block h-5 w-5"
			style={"background-position:center center;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 22 22'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill-rule='nonzero'%3E%3Cpath fill='%23888' d='M2 6h1v9H2zM18.056 6h1v9h-1z'/%3E%3Cpath fill='%23888' d='M2 6h17v1H2z'/%3E%3Cg fill='%23CB4545'%3E%3Cpath d='M16.032.918v3.109h-.9V.918zM16.032 6.809v3.109h-.9V6.809zM17.03 4.99l3.109.055-.016.9-3.11-.054zM11.138 4.99l3.11.055-.016.9-3.11-.054z'/%3E%3Cpath d='M15.582 1.9a3.518 3.518 0 1 0 0 7.036 3.518 3.518 0 0 0 0-7.036zm0 .9a2.618 2.618 0 1 1 0 5.236 2.618 2.618 0 0 1 0-5.236z'/%3E%3C/g%3E%3C/g%3E%3Cpath d='M0 0h22v22H0z'/%3E%3C/g%3E%3C/svg%3E\")"}
		/>;
	}
	statsCornerIcon() {
		return <span
			title={window.Translation(msg`Corners`)}
			class="inline-block h-5 w-5"
			style={"background-position:center center;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='22' height='22' viewBox='0 0 22 22'%3E%3Cdefs%3E%3Cpath id='a' d='M0 .1c2.2 1.298 5.2 2.3 9 3.006-3.884 2.37-6.884 3.372-9 3.007V.1z'/%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(8 4.5)'%3E%3Cpath fill='%23E83838' fill-rule='nonzero' d='M0 .1c2.2 1.298 5.2 2.3 9 3.006-3.884 2.37-6.884 3.372-9 3.007V.1z'/%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cpath fill='%23000' fill-rule='nonzero' d='M0 .1C.464.02 2.21.093 2.671.1c1.825 2.112-2.504 1.552-1.4 6.006-.337.95-.813.362-1.271.007V.1z' mask='url(%23b)' opacity='.2'/%3E%3C/g%3E%3Cpath fill='%23888' fill-rule='nonzero' d='M7 4.142a.953.953 0 0 1 1 0v12.734c-.267.152-.747.178-1 0V4.142z'/%3E%3Cpath d='M0 0h22v22H0z'/%3E%3C/g%3E%3C/svg%3E\")"}
		/>;
	}
	statsYellowCardIcon() {
		return <span
			title={window.Translation(msg`Cartellino Giallo`)}
			class="inline-block h-5 w-5"
			style={"background-position:center center;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 22 22'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23FFDF1B' stroke='%23D4D4D4' d='M7 5.5h8.273v11H7z'/%3E%3Cpath d='M0 0h22v22H0z'/%3E%3C/g%3E%3C/svg%3E\")"}
		/>;
	}
	statsRedCardIcon() {
		return <span
			title={window.Translation(msg`Cartellino Rosso`)}
			class="inline-block h-5 w-5"
			style={"background-position:center center;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 22 22'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23E83838' d='M7.5 6h7.273v10H7.5z'/%3E%3Cpath d='M0 0h22v22H0z'/%3E%3C/g%3E%3C/svg%3E\")"}
		/>;
	}
	getStatsValue(event, team, stats) {
		// "stats" può essere passato come array di valori alternativi per il nome
		// di una statistica perchè ho visto uscire nel feed alcune volte "red_card",
		// altre volte "redcard"

		const t = team + '_value';

		if (typeof stats === 'string') {
			stats = [stats];
		}

		for (let i = 0; i < stats.length; ++i) {
			const s = stats[i];
			if (!event || !event.misc || !event.misc.stats || !event.misc.stats[s] || !event.misc.stats[s][t]) {
				continue;
			}
			return event.misc.stats[s][t];
		}

		return '-';
	}
	render({event}) {
		return <div ref={r => this.root = r} onClick={e => e.stopPropagation()} class={"text-black text-xs flex flex-col items-center justify-center border rounded border-black bg-white absolute -top-24 z-50 -right-2"}>
			<div class="flex w-full">
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.statsDangerAttackIcon()}</div>
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.statsAttackIcon()}</div>
				{/*<div class="grow-0 shrink-0 w-7 text-center p-1">{this.statsBallPossesionIcon()}</div>*/}
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.statsShotOnTargetIcon()}</div>
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.statsShotOffTargetIcon()}</div>
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.statsCornerIcon()}</div>
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.statsYellowCardIcon()}</div>
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.statsRedCardIcon()}</div>
			</div>
			<div class="flex w-full">
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.getStatsValue(event, 'team1', 'dangerous_attack')}</div>
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.getStatsValue(event, 'team1', 'attack')}</div>
				{/*<div class="grow-0 shrink-0 w-7 text-center p-1">-</div>*/}
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.getStatsValue(event, 'team1', 'shot_on_target')}</div>
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.getStatsValue(event, 'team1', 'shot_off_target')}</div>
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.getStatsValue(event, 'team1', 'corner')}</div>
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.getStatsValue(event, 'team1', ['yellow_card','yellowcard'])}</div>
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.getStatsValue(event, 'team1', ['red_card','redcard'])}</div>
			</div>
			<div class="flex w-full">
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.getStatsValue(event, 'team2', 'dangerous_attack')}</div>
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.getStatsValue(event, 'team2', 'attack')}</div>
				{/*<div class="grow-0 shrink-0 w-7 text-center p-1">-</div>*/}
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.getStatsValue(event, 'team2', 'shot_on_target')}</div>
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.getStatsValue(event, 'team2', 'shot_off_target')}</div>
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.getStatsValue(event, 'team2', 'corner')}</div>
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.getStatsValue(event, 'team2', ['yellow_card','yellowcard'])}</div>
				<div class="grow-0 shrink-0 w-7 text-center p-1">{this.getStatsValue(event, 'team2', ['red_card','redcard'])}</div>
			</div>
		</div>;
	}
}

export class MarketSection extends Component {
	state = {
		setMarket: null,
		open: false
	}
	openDropdown() {
		if (this.state.open)
			return;
		this.setState({open: true});
		requestAnimationFrame(() => window.document.addEventListener('click', this.onClick = e => {
			console.log("ECCOMI");
			window.document.removeEventListener('click', this.onClick)
			this.setState({open: false});
		}))
	}
	render({markets}) {
		const setMarket = markets[this.state.setMarket] || Object.values(markets).sort((a, b) => a.order - b.order)[0];
		if (!setMarket) {
			return <L.HiddenNotifyContainer>
				<L.HiddenNotify>Sorry, no odds for this match</L.HiddenNotify>
			</L.HiddenNotifyContainer>
		} else {
			return <L.MarketResultContainer>
				<L.MarketResultRow>
				  <L.DropdownButton onClick={e => this.openDropdown()}>
				    <I.UpArrowIcon class={"h-4 transition-transform "+(this.state.open ? '' : 'rotate-180')} />
				  </L.DropdownButton>
				  <L.MarketResult onClick={e => this.openDropdown()}>{setMarket.name}</L.MarketResult>
				  <L.DropdownHiddenContainer active={this.state.open}>
					  {Object.values(markets).map(market => (
						<L.DropdownRow active={setMarket == market} onClick={e => this.setState({setMarket: market.id})}>{market.name}</L.DropdownRow>
					  ))}
				  </L.DropdownHiddenContainer>
				</L.MarketResultRow>
				<L.OutcomeButtonContainer>
				  {Object.values(setMarket.sub).map(outcome => (
					<E.OutcomeButton
						   selected={Ticket.hasLiveOdds(outcome.id)}
						   onClick={() => Ticket.toggleLiveOdds(outcome.id)}>
					  <E.OutcomeName>{outcome.name}</E.OutcomeName>
					  <E.OutcomeValue selected={Ticket.hasLiveOdds(outcome.id)} value={outcome.value} />
					</E.OutcomeButton>
				  ))}
				</L.OutcomeButtonContainer>
			</L.MarketResultContainer>
		}
	}
}
